import { render, staticRenderFns } from "./Testimonials.vue?vue&type=template&id=4c772624&"
import script from "./Testimonials.vue?vue&type=script&lang=ts&"
export * from "./Testimonials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports